import Vue from 'vue'
import Router from 'vue-router'
import { getCookie, setCookie } from "@/ask/cookiejs";


//前台页面
import indexPage from '../components/reception/indexPage.vue'
//前台页面 头部尾部公用
import aboutUs from '../components/reception/otherPage/aboutUs.vue'
import printPage from '../components/reception/otherPage/printPage.vue'
import Terms from '../components/reception/otherPage/Terms.vue'
import privacy from '../components/reception/otherPage/privacy.vue'
import refund from '../components/reception/otherPage/refund.vue'
import adepm from '../components/reception/otherPage/adepm.vue'
import frontPickupService from '../components/reception/pickUp/frontPickupService.vue'

// 前台未登录查价
import front from '@/components/reception/indexCom.vue'
import frontAir from '@/components/reception/air'
import frontExpress from '@/components/reception/express'
//登录注册页面
import login from '../components/reception/reg/login.vue'
import regCom from '../components/reception/reg/regCom.vue'
import registerCst from '../components/reception/reg/registerCst.vue'
import emailAct from '../components/reception/reg/emailAct.vue'
import findPwd from '../components/reception/reg/findPwd.vue'

//用户中心页面路由
import userCenterCom from '../components/userCenter/userCenterCom.vue'
// import myUserCenter from '../components/userCenter/myUserCenter.vue'
import quotes from '../components/userCenter/quotes'

import expListPage from '../components/userCenter/exp/expList.vue'
import expDetailsPage from '../components/userCenter/exp/expDetails.vue'

// import checkExpList from '../components/userCenter/exp/checkExpList.vue'
import expEdit from '../components/userCenter/exp/expEdit.vue'
import expSucceed from '../components/userCenter/exp/expSucceed.vue'
import myInvoice from '../components/userCenter/myInfo/myInvoice.vue'
import basicInfo from '../components/userCenter/myInfo/basicInfo.vue'
import workTeamDesc from '../components/userCenter/myInfo/workTeamDesc.vue'
import myAirPriceStore from '../components/userCenter/myInfo/myAirPriceStore.vue'
import myAirPriceStoreDetail from '../components/userCenter/myInfo/myAirPriceStoreDetail.vue'
import CommonInvoice from '../components/userCenter/myInfo/CommonInvoice.vue'
import myAccount from '../components/userCenter/payment/myAccount.vue'
import mybill from '../components/userCenter/payment/mybill.vue'
import myPayment from '../components/userCenter/payment/myPayment.vue'
import pickUpOrder from '../components/userCenter/pickUp/pickUpOrder.vue'
import pickUpEdit from '../components/userCenter/pickUp/pickUpEdit.vue'
import pickUpList from '../components/userCenter/pickUp/pickUpList.vue'
import pickUpSuccess from '../components/userCenter/pickUp/pickUpSuccess.vue'
import airDelegate from '../components/userCenter/myInfo/airDelegate.vue'
import serviceEvaluation from '../components/userCenter/myInfo/serviceEvaluation.vue'
import notice from '../components/userCenter/myInfo/notice.vue'
import myAdvice from '../components/userCenter/myInfo/myAdvice.vue'
import statement from '../components/userCenter/statement/statement.vue'

//提货
// import pickupService from '../components/userCenter/pickup/pickupService.vue'
import pickupDetails from '../components/userCenter/pickup/pickupDetails.vue'

import customerInquiry from '../components/userCenter/myInquiry/customerInquiry.vue'
import airInquiry from '../components/userCenter/myInquiry/airInquiry.vue'
import airInDetails from '../components/userCenter/myInquiry/airInDetails.vue'

import airInPrint from '../components/userCenter/myInquiry/airInPrint.vue' //我的报价单-打印预览


//发票预览
import CommonInvoicePreview from '../components/userCenter/myInfo/CommonInvoicePreview.vue'

//空运页面
import checkAirList from '../components/userCenter/air/checkAirList.vue'
import airDetails from '../components/userCenter/air/airDetails.vue'
import airEdit from '../components/userCenter/air/airEdit.vue'
import airListPage from '../components/userCenter/air/airList.vue'
import airSucceed from '../components/userCenter/air/airSucceed.vue'

// 分享页面
import receiptExpDetails from '@/components/receiptPage/exp/receiptExpDetails.vue'
import receiptAirDetails from '@/components/receiptPage/exp/receiptAirDetails.vue'
import receipt from '@/components/receiptPage/receipt.vue'

Vue.use(Router)
const router = new Router({
  mode: 'history',
  routes: [
    //首页
    { path: '/', name: 'indexPage', component: indexPage, },
    // 退订成功
    { path: '/unSubscriptionConfirmed', name: 'unSubscriptionConfirmed', component: () => import('../components/public/unSubscriptionConfirmed.vue'), meta: { title: '退订成功' } },
    //关于百运
    { path: '/aboutUs', name: 'aboutUs', component: aboutUs, },
    { path: '/printPage', name: 'printPage', component: printPage, },
    { path: '/Terms', name: 'Terms', component: Terms, },
    { path: '/privacy', name: 'privacy', component: privacy, },
    { path: '/refund', name: 'refund', component: refund, },

    // {path: '/adepm', name: 'adepm', component: adepm,},    

    //注册页面、忘记密码
    {
      path: '/regCom', name: 'regCom', component: regCom,
      children: [
        { path: '/reg/registerCst', name: 'registerCst', component: registerCst, meta: { title: '注册' } },
        { path: '/reg/registerPeer', name: 'registerPeer', component: () => import('../components/reception/reg/registerPeer.vue'), meta: { title: '注册peer' } },
        { path: '/reg/emailAct', name: 'emailAct', component: emailAct, meta: { title: '注册邮箱激活' } },
        { path: '/reg/findPwd', name: 'findPwd', component: findPwd, meta: { title: '忘记密码' } },
      ]
    },
    //注册页面、忘记密码
    {
      path: '/front', name: 'front', component: front,
      children: [
        { path: '/front/air', name: 'frontAir', component: frontAir, meta: { title: '未登录空运' } },
        { path: '/front/express', name: 'frontExpress', component: frontExpress, meta: { title: '未登录快递' } },
        { path: '/front/pickupService', name: 'frontPickupService', component: frontPickupService, meta: { title: '取件查价' } },
      ]
    },
    //登录页面
    { path: '/reg/login', name: 'login', component: login, },

    //用户中心
    {
      path: '/userCenterCom', name: 'userCenterCom', component: userCenterCom,
      children: [
        // 首页不要了 但是有可能又要
        //  {path: '/myUserCenter', name: 'myUserCenter', component:myUserCenter, meta: {title: '我的百运'}},
        { path: '/checkList/quotes', name: 'quotes', component: quotes, meta: { title: '查价' } },
        { path: '/exp/expList', name: 'expListPage', component: expListPage, meta: { title: '快递订单列表页面' } },
        { path: '/exp/expDetails', name: 'expDetailsPage', component: expDetailsPage, meta: { title: '快递订单详情' } },
        //  {path: '/exp/checkExpList', name: 'checkExpList', component:checkExpList, meta: {title: '快递查价下单',}},
        { path: '/exp/expEdit', name: 'expEdit', component: expEdit, meta: { title: '快递订单编辑' } },
        { path: '/exp/expSucceed', name: 'expSucceed', component: expSucceed, meta: { title: '快递订单下单成功' } },
        { path: '/myInfo/myInvoice', name: 'myInvoice', component: myInvoice, meta: { title: '我的发票' } },
        { path: '/myInfo/CommonInvoice', name: 'CommonInvoice', component: CommonInvoice, meta: { title: '编辑我的发票' } },
        { path: '/myInfo/basicInfo', name: 'basicInfo', component: basicInfo, meta: { title: '我的信息' } },
        { path: '/myInfo/workTeamDesc', name: 'workTeamDesc', component: workTeamDesc, meta: { title: '我的工作组描述' } },
        { path: '/myInfo/myAirPriceStore', name: 'myAirPriceStore', component: myAirPriceStore, meta: { title: '我的存储报价' } },
        { path: '/myInfo/myAirPriceStoreDetail', name: 'myAirPriceStoreDetail', component: myAirPriceStoreDetail, meta: { title: '我的存储报价详情' } },
        { path: '/payment/myAccount', name: 'myAccount', component: myAccount, meta: { title: '我的账户' } },
        { path: '/payment/mybill', name: 'mybill', component: mybill, meta: { title: '我的账单' } },
        { path: '/payment/myPayment', name: 'myPayment', component: myPayment, meta: { title: '我的支付' } },

        { path: '/myInfo/airDelegate', name: 'airDelegate', component: airDelegate, meta: { title: '空运委托书' } },
        { path: '/myInfo/myAdvice', name: 'myAdvice', component: myAdvice, meta: { title: '我的建议' } },
        { path: '/serviceEvaluation', name: 'serviceEvaluation', component: serviceEvaluation, meta: { title: '服务评价' } },

        //提货
        //  {path: '/pickup/pickupService', name: 'pickupService', component:pickupService, meta: {title: '提货下单',}},
        { path: '/pickup/pickupDetails', name: 'pickupDetails', component: pickupDetails, meta: { title: '提货订单详情' } },
        { path: '/pickUp/pickUpOrder', name: 'pickUpOrder', component: pickUpOrder, meta: { title: '预约取件上门' } },
        { path: '/pickUp/pickUpEdit', name: 'pickUpEdit', component: pickUpEdit, meta: { title: '预约取件编辑' } },
        { path: '/pickUp/pickUpList', name: 'pickUpList', component: pickUpList, meta: { title: '预约取件列表' } },
        { path: '/pickUp/PickupOrderSucceed', name: 'pickUpSuccess', component: pickUpSuccess, meta: { title: '预约取件下单成功' } },

        //空运         
        { path: '/air/checkAirList', name: 'checkAirList', component: checkAirList, meta: { title: '空运查价页面', } },
        { path: '/air/airDetails', name: 'airDetails', component: airDetails, meta: { title: '空运订单详情页面' } },
        { path: '/air/airEdit', name: 'airEdit', component: airEdit, meta: { title: '空运订单编辑' } },
        { path: '/air/airList', name: 'airListPage', component: airListPage, meta: { title: '空运订单列表页面' } },
        { path: '/air/airSucceed', name: 'airSucceed', component: airSucceed, meta: { title: '空运订单下单成功页面' } },
        //大货
        { path: '/myInquiry/customerInquiry', name: 'customerInquiry', component: customerInquiry, meta: { title: '大货单询' } },
        { path: '/myInquiry/airInquiry', name: 'airInquiry', component: airInquiry, meta: { title: '我的询盘' } },
        { path: '/myInquiry/airInDetails', name: 'airInDetails', component: airInDetails, meta: { title: '我的询盘' } },
        // 通知 
        { path: '/myInfo/notice', name: 'notice', component: notice, meta: { title: '我的通知' } },
        { path: '/statement', name: 'statement', component: statement, meta: { title: 'statement' } },


      ]
    },
    //发票预览
    { path: '/myInfo/CommonInvoicePreview', name: 'CommonInvoicePreview', component: CommonInvoicePreview, },
    //我的询价-报价单预览页面
    { path: '/myInquiry/airInPrint', name: 'airInPrint', component: airInPrint, meta: { title: '打印报价单' }, },
    {
      path: '/receipt', name: 'receipt', component: receipt,
      children: [
        { path: '/receiptPage/exp/receiptExpDetails', name: 'receiptExpDetails', component: receiptExpDetails, meta: { title: '快递收货界面' } },
        { path: '/receiptPage/air/receiptAirDetails', name: 'receiptAirDetails', component: receiptAirDetails, meta: { title: '空运分享界面' } },
      ]
    },
  ]
})


// 对路由做控制
router.beforeEach((to, from, next) => {
  if (to.name === 'customerInquiry' && !sessionStorage.getItem("customerInquiry")) {
    // 如果是去customerInquiry页面 没有相应数据就打回原页面
    next({
      path: '/checkList/quotes',
    })
  }
  //console.log("......",to,from,getCookie("X-BY-EnTOKEN"));
  if (to.matched[0].path === "/userCenterCom" && !getCookie("X-BY-EnTOKEN")) {
    next({
      path: '/reg/login',
    })
  }


  setTimeout(() => {
    next();
    // 埋点
    sensors.quick("autoTrackSinglePage"); // after the next(); statement
    sensors.quick('isReady', function () {
      sensors.quick('getAnonymousID');
      console.log('getAnonymousID: ' + sensors.quick('getAnonymousID'));
    });
  }, 0);
  // next() //给通过
})


export default router


// WEBPACK FOOTER //
// ./src/router/index.js